/**
 * Class representing a Safie device (camera).
 */
class SafieDevice {
    /**
     * Create a safie device.
     * @param {Object} data - Device data
     * @param {string} data.id - Device ID
     * @param {string} data.name - Device name
     * @param {Array} data.coord - Device coordinates in [longitude, latitude] format
     * @param {number} data.bearing - Device bearing in degrees
     * @param {number} [data.altitude=0] - Device altitude in meters
     */
    constructor({id, name, coord, bearing, altitude = 0, latestsnapshot = null, updatedAt = null}) {
        const me = this;

        me.id = id;
        me.name = name;
        me.coord = coord;
        me.bearing = bearing;
        me.altitude = altitude;
        me.latestsnapshot = latestsnapshot; // 最新のスナップショット画像データ
        me.updatedAt = updatedAt; // 更新日時
        me.color = '#0066FF'; // Safie blue color
        me.type = 'safie-device';
        me.outline = 0.5;
    }

    /**
     * デバイス情報を更新する
     * @param {Object} data - 更新データ
     */
    update(data) {
        const me = this;
        
        if (data.coord) me.coord = data.coord;
        if (data.bearing !== undefined) me.bearing = data.bearing;
        if (data.altitude !== undefined) me.altitude = data.altitude;
        if (data.latestsnapshot !== undefined) me.latestsnapshot = data.latestsnapshot;
        if (data.name) me.name = data.name;
        if (data.updatedAt !== undefined) me.updatedAt = data.updatedAt;
    }

    /**
     * 署名付きURL形式の画像データURL取得
     * @returns {string|null} 署名付きURL または null
     */
    getImageDataUrl() {
        const me = this;
        
        if (!me.latestsnapshot) {
            return null;
        }
        
        // 署名付きURLの場合（文字列として保存されている）
        if (typeof me.latestsnapshot === 'string') {
            // S3署名付きURLをそのまま返す
            return me.latestsnapshot;
        }
        
        return null;
    }
}

export default SafieDevice;